import { useStyles } from "../../useRCASettingsColumns.styles";
import { useContext, useMemo, useState } from "react";
import { IRCASettings } from "entities/RCA/RCASettingsEntity/RCASettingsEntityInterfaces";
import { useTranslation } from "react-i18next";
import NewMainSelect from "components/NewMainSelect/NewMainSelect.view";
import { RCASettingsContext } from "contexts/RCASettingsContext.ts/RCASettingsContext";

const RCASettingsOwnerSelect = ({ row, canEdit }: { row: IRCASettings; canEdit: boolean | undefined }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { rcaSettingsChanges, setRcaSettingsChanges } = useContext(RCASettingsContext);
    const currentChanges = useMemo(
        () =>
            rcaSettingsChanges.find(
                (rcaSetting) =>
                    rcaSetting.production_line_id === row.production_line_id &&
                    rcaSetting.failure_type.failure_type_id === row.failure_type.failure_type_id,
            ),
        [rcaSettingsChanges, row],
    );
    const [value, setValue] = useState<number | undefined>(
        currentChanges?.owner_id || (row?.owner_id ? row?.owner_id : undefined),
    );
    const selectionRequired = useMemo(
        () =>
            (currentChanges?.rca_duration_trigger.is_enabled || currentChanges?.rca_frequency_trigger.is_enabled) &&
            !value,
        [currentChanges, value],
    );

    return (
        <NewMainSelect
            className={selectionRequired ? classes.requiredBorderSelect : classes.select}
            fullWidth
            size="small"
            placeholder={t("rca.settings.owners_dropdown.select_owner")}
            options={row.owners_options.map((option) => ({
                id: option.user_id,
                name: `${option.first_name} ${option.last_name}`,
                picture: option?.media?.media_url || "",
            }))}
            disabled={
                (currentChanges !== undefined
                    ? !(
                          currentChanges?.rca_frequency_trigger?.is_enabled ||
                          currentChanges?.rca_duration_trigger?.is_enabled
                      )
                    : !(row?.rca_frequency_trigger?.is_enabled || row?.rca_duration_trigger?.is_enabled)) || !canEdit
            }
            value={value || ""}
            onChange={(selected) => {
                setRcaSettingsChanges((prev) => {
                    let prevRcaSettings = [...prev];
                    const existingSettings = prevRcaSettings.findIndex(
                        (rcaSetting) =>
                            rcaSetting.production_line_id === row.production_line_id &&
                            rcaSetting.failure_type.failure_type_id === row.failure_type.failure_type_id,
                    );
                    if (existingSettings === -1) {
                        return [
                            ...prevRcaSettings,
                            {
                                ...row,
                                owner_id: Number(selected),
                            },
                        ];
                    } else {
                        prevRcaSettings[existingSettings] = {
                            ...prevRcaSettings[existingSettings],
                            owner_id: Number(selected),
                        };
                        return prevRcaSettings;
                    }
                });
                setValue(Number(selected));
            }}
            multiple={false}
            withAvatar
            withSearchBar
        />
    );
};

export default RCASettingsOwnerSelect;
